import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SupplierProductShow = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [name, setName] = useState("");
  const [size, setSize] = useState("");
  const [printCovarage, setPrintCoverage] = useState("");
  const [paperGsm, setPaperGSM] = useState("");
  const [status, setStatus] = useState("");
  const [noOfPly, setNoOfPly] = useState("");
  const [materialColor, setMaterialColor] = useState("");
  const [quantity, setQuantity] = useState("");
  const [burst_factor, setBurstFactor] = useState("");
  const [created_at, setcreated_at] = useState("");
  const [description, setDescription] = useState("");
  const [product_image, setProduct_image] = useState("");
  const [lamination, setLamination] = useState("");

  useEffect(() => {
    if (location?.state === null) {
      Navigate("/admin/dashboard");
    } else {
      setName(location?.state?.name);
      setSize(location?.state?.size);
      setPrintCoverage(location?.state?.print_coverage);
      setPaperGSM(location?.state?.paper_gsm);
      setStatus(location?.state?.status);
      setNoOfPly(location?.state?.no_of_ply);
      setMaterialColor(location?.state?.material_color);
      setBurstFactor(location?.state?.burst_factor);
      setQuantity(location?.state?.quantity);
      setcreated_at(location?.state?.created_at);
      setDescription(location?.state?.description);
      setProduct_image(location?.state?.product_image);
      setLamination(location?.state?.lamination);
    }
  }, []);

  const strip = (html = "") => (html || "").replace(/<[^>]+>/g, "");
  const initials = (name || "P").trim().slice(0, 2).toUpperCase();

  const images = (() => {
    if (!product_image) return [];
    try {
      const parsed = JSON.parse(product_image);
      return Array.isArray(parsed) ? parsed : [product_image];
    } catch (e) {
      return [product_image];
    }
  })();

  const Field = ({ label, value, mono }) => (
    <div>
      <div className="al-spec__lbl">{label}</div>
      <div className="al-spec__val" style={mono ? { fontFamily: "var(--font-mono)" } : undefined}>
        {value || value === 0 ? value : "—"}
      </div>
    </div>
  );

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Supplier Product Details</h1>
          <p className="al-sub">Product listed by the supplier with full specification.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        <div className="al-idbanner__icon">{initials}</div>
        <div style={{ minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <h2 className="al-idbanner__name">{name || "Product"}</h2>
            <span className="al-pill" style={{ background: status ? "var(--color-success-bg)" : "var(--color-surface-2)", color: status ? "var(--color-success-text)" : "var(--color-text-secondary)" }}>
              {status ? "Active" : "Deactive"}
            </span>
          </div>
          <p className="al-idbanner__sub">{name ? `${name} · supplier product` : "Supplier product"}</p>
        </div>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></svg>
          </div>
          <h3 className="al-cardhead__title">Specification</h3>
        </div>
        <div className="al-spec">
          <Field label="Name" value={name} />
          <Field label="Size" value={size} mono />
          <Field label="Quantity" value={quantity} mono />
          <Field label="Burst Factor" value={burst_factor} mono />
          <Field label="Print Coverage" value={printCovarage} />
          <Field label="Paper GSM" value={paperGsm} mono />
          <Field label="No of Ply" value={noOfPly} mono />
          <Field label="Material Color" value={materialColor} />
          <Field label="Lamination" value={lamination} />
          <div className="al-spec__full">
            <div className="al-spec__lbl">Description</div>
            <div className="al-spec__val">{strip(description) || "—"}</div>
          </div>
          <div className="al-spec__full">
            <div className="al-spec__lbl">Product Image</div>
            {images.length > 0 ? (
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 2 }}>
                {images.map((img, idx) => (
                  <button key={idx} type="button"
                    onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL}${img}`, "_blank")}
                    style={{ width: 72, height: 72, borderRadius: 11, overflow: "hidden", border: "1px solid var(--color-border)", background: "var(--color-surface-2)", cursor: "pointer", padding: 0 }}>
                    <img src={`${process.env.REACT_APP_IMAGE_URL}${img}`} alt={`Product ${idx + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </button>
                ))}
              </div>
            ) : (
              <div className="al-spec__val al-muted">No Image found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierProductShow;
